/**
 * Route Constants
 * 
 * All application routes defined as constants.
 * This is the ONLY file that should contain route strings.
 * 
 * ESLint rule `no-route-literals-outside-routing` enforces this.
 */

export const ROUTES = {
  // Public routes
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  
  // Legal routes
  LEGAL_TERMS: '/legal/terms',
  LEGAL_PRIVACY: '/legal/privacy',
  LEGAL_AI_USE: '/legal/ai-use',
  
  // Dashboard
  DASHBOARD: '/app/dashboard',
  
  // Library routes
  LIBRARY: '/app/library',
  LIBRARY_UPLOAD: '/app/library/upload',
  LIBRARY_DOCUMENT: '/app/library/:documentId',
  
  // Project routes
  PROJECTS: '/app/projects',
  PROJECTS_NEW: '/app/projects/new',
  PROJECT_DETAIL: '/app/projects/:projectId',
  PROJECT_QUESTIONS: '/app/projects/:projectId/questions',
  PROJECT_QUESTION_DETAIL: '/app/projects/:projectId/questions/:questionId',
  PROJECT_REVIEW: '/app/projects/:projectId/review',
  PROJECT_GENERATE: '/app/projects/:projectId/generate',
  PROJECT_EXPORT: '/app/projects/:projectId/export',
  
  // Exports routes
  EXPORTS: '/app/exports',
  EXPORT_DETAIL: '/app/exports/:exportId',
  
  // Admin routes
  ADMIN: '/app/admin',
  ADMIN_USERS: '/app/admin/users',
  ADMIN_WORKSPACE: '/app/admin/workspace',
  ADMIN_AUDIT: '/app/admin/audit',
  ADMIN_RETENTION: '/app/admin/retention',
  ADMIN_POLICIES: '/app/admin/policies',
  
  // Settings routes
  SETTINGS: '/app/settings',
  SETTINGS_PROFILE: '/app/settings/profile',
  SETTINGS_SECURITY: '/app/settings/security',
  
  // Billing routes (owner only)
  BILLING: '/app/billing',
  
  // Utility routes
  STATUS: '/app/status',
  FORBIDDEN: '/app/403',
  NOT_FOUND: '/app/404',
  
  // Dev-only routes (excluded from production builds)
  DEV_WORKSPACE_ISOLATION_TEST: '/app/dev/workspace-isolation-test',
  
} as const;
